const STORE_FIELD_MESSAGES = {
  STORE_CODE_REQUIRED: {
    field: "storeCode",
    message: "Store code is required.",
  },
  STORE_SLUG_REQUIRED: {
    field: "storeSlug",
    message: "Store slug is required.",
  },
  STORE_NAME_REQUIRED: {
    field: "storeName",
    message: "Store name is required.",
  },
  STORE_CODE_EXISTS: {
    field: "storeCode",
    message: "This store code already exists for this business.",
  },
  STORE_SLUG_EXISTS: {
    field: "storeSlug",
    message: "This store slug is already in use. Please choose another.",
  },
};

const CODE_MESSAGES = {
  BUSINESS_NOT_FOUND:
    "Business not found. Please go back and choose a valid business.",
  STORE_NOT_FOUND: "Store not found. It may have been removed.",
  MAX_STORES_EXCEEDED:
    "Store limit reached for this business. Update license allocation to add another store.",
  STORE_LIMIT_EXCEEDED:
    "Store limit reached for this business. Update license allocation to add another store.",
};

export const getProblemCode = (error) => {
  const data = error?.data || {};
  const rawCode = data.code || data.errorCode || data.title;
  if (typeof rawCode === "string" && rawCode.trim()) {
    return rawCode.trim().toUpperCase();
  }
  return "";
};

export const getProblemDetail = (error) => {
  const detail = error?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail.trim();
  }
  return "";
};

export const getStoreProblemInfo = (error, { operation = "save" } = {}) => {
  const code = getProblemCode(error);
  const detail = getProblemDetail(error);

  const fieldErrors = {};
  const fieldMeta = STORE_FIELD_MESSAGES[code];
  if (fieldMeta) {
    fieldErrors[fieldMeta.field] = fieldMeta.message;
  }

  if (Array.isArray(error?.data?.errors)) {
    error.data.errors.forEach((entry) => {
      const field = entry?.field;
      const message = entry?.message;
      if (typeof field === "string" && typeof message === "string") {
        fieldErrors[field] = message;
      }
    });
  }

  const fallbackMessage =
    operation === "load"
      ? "Failed to load store data."
      : operation === "status"
        ? "Failed to update store status."
        : "Failed to save store.";

  const message =
    CODE_MESSAGES[code] ||
    (fieldMeta ? fieldMeta.message : "") ||
    detail ||
    fallbackMessage;

  return {
    code,
    message,
    fieldErrors,
    showLicenseBanner:
      code === "MAX_STORES_EXCEEDED" || code === "STORE_LIMIT_EXCEEDED",
  };
};

export const getProblemTitle = (error) => getProblemCode(error);

export const isLicenseExpiredProblem = (error) =>
  getProblemCode(error) === "LICENSE_EXPIRED";
